/** ***********
*
* <dev-tools.service.ts v1.0>
*
* Copyright (c) 2022 AIRBUS OPERATIONS
*
* Contributors:
*  pranshushrivastav [pranshu.shrivastav@soprasteria.com]
*
* All rights reserved.
**************/

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EventDev, PlannedLine } from 'src/app/models/dev-tools.model';

@Injectable({
    providedIn: 'root',
})
export class DevToolsService {

    constructor(private http: HttpClient) { }

    /**
     * Generate a new event
     */
    public postEvent(event: EventDev): Observable<void> {
        return this.http.post<void>(`${environment.API_ENDPOINT}/test-events`, event);
    }

    /**
     *
     * planning
     */
    public postPlanning(planning: string): Observable<void> {
        return this.http.post<void>(`${environment.API_ENDPOINT}/test-plannings`, planning);
    }

    /**
     * planned line
     * @param : planned line's body
     */
    public postPlannedLine(planning: PlannedLine): Observable<void> {
        return this.http.post<void>(`${environment.API_ENDPOINT}/test-planned-line`, planning);
    }
}
